export * from '@/api/mock_chart';

export const lorem = `Lorem ipsum dolor sit amet, mel at clita quando.
   Te sit oratio vituperatoribus,
   nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi
   vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`;

export const landingInfo = {
  title: 'Vue Vuetify Admin',
  email: 'example@mail.com',
  phone: '+79876543210',
  adres: 'Yekaterinburg',
};

export const userAdmin = {
  email: 'orlando@apollo.com.ph',
  password: 'ap0ll0',
  user: 'Orly',
  status: 'admin',
  code: '',
  token: '3b759a9ca80234563d87672350659b2b',
  name: 'Orlando Sarceda',
  avatar: 'https://avatars.githubusercontent.com/u/13101802',
  roles: ['admin', 'editor'],
};

export const userEditor = {
  email: 'editor@vvadmin.io',
  password: 'abcd1234',
  user: 'Editor',
  status: '',
  code: '',
  token: '09d0a5b30b267c2504fadd43348fbba3',
  name: 'Editor Name',
  avatar: '',
  roles: ['editor'],
};
